import { getItem } from '@/utility/localStorageControl';

export default [
  // // redirect from / to /assessment
  // {
  //   path: '/',
  //   redirect: () => {
  //     return '/assessment';
  //   },
  // },
  {
    path: '/assessment',
    name: 'assessment',
    component: () => import(/* webpackChunkName: "assessment" */ '@/view/assessment/index.vue'),
    redirect: () => {
      const permissions = getItem('permissions');
      const profile = getItem('profile_plnbb');

      if (profile) {
        const roles = profile.roles;

        if (roles) {
          const hasSuperUserAssessment = roles.some(role => role.name === 'Super User Assessment');

          if (hasSuperUserAssessment) {
            return '/assessment/pembinaan';
          }
        }
      }

      /* if (roles.includes('Super User Assessment')) {
        return '/assessment/pembinaan';
      } */

      if (permissions.includes('approve 1 assesment') || permissions.includes('approve 2 assesment')) {
        return '/assessment/approval';
      } else if (permissions.includes('report assesment')) {
        return '/assessment/reporting';
      } else {
        return '/assessment/pembinaan';
      }
    },
    children: [
      {
        path: 'pembinaan',
        name: 'pembinaan',
        component: () => import(/* webpackChunkName: "pembinaan" */ '@/view/assessment/pembinaan.vue'),
        meta: { auth: true },
      },
      {
        path: 'approval',
        name: 'approval',
        component: () => import(/* webpackChunkName: "approval" */ '@/view/assessment/approval.vue'),
        meta: { auth: true },
      },
      {
        path: 'monitoring',
        name: 'monitoring',
        component: () => import(/* webpackChunkName: "monitoring" */ '@/view/assessment/monitoring.vue'),
        meta: { auth: true },
      },
      {
        path: 'pengajuan',
        name: 'pengajuan',
        component: () => import(/* webpackChunkName: "pengajuan" */ '@/view/assessment/pengajuan.vue'),
        meta: { auth: true },
      },
      {
        path: 'reporting',
        name: 'reporting',
        component: () => import(/* webpackChunkName: "reporting" */ '@/view/assessment/report.vue'),
        meta: { auth: true },
      },
      {
        path: 'detail',
        name: 'detail',
        component: () => import(/* webpackChunkName: "reporting" */ '@/view/assessment/reportDetail.vue'),
        meta: { auth: true },
      },
      {
        path: 'master',
        name: 'master',
        component: () => import(/* webpackChunkName: "master-assessment" */ '@/view/assessment/master/index.vue'),
        meta: { auth: true },
        children: [
          {
            path: 'periode',
            name: 'periode',
            component: () => import(/* webpackChunkName: "periode" */ '@/view/assessment/master/periode/index.vue'),
          },
          {
            path: 'periode-add',
            name: 'periode-add',
            component: () => import(/* webpackChunkName: "periode-add" */ '@/view/assessment/master/periode/add.vue'),
          },
          {
            path: 'periode-edit/:id',
            name: 'periode-edit',
            component: () => import(/* webpackChunkName: "periode-edit" */ '@/view/assessment/master/periode/edit.vue'),
          },
          {
            path: 'proyeksi-jabatan',
            name: 'proyeksi-jabatan',
            component: () =>
              import(/* webpackChunkName: "proyeksi-jabatan" */ '@/view/assessment/master/proyeksi-jabatan/index.vue'),
          },
          {
            path: 'proyeksi-jabatan-add',
            name: 'proyeksi-jabatan-add',
            component: () =>
              import(
                /* webpackChunkName: "proyeksi-jabatan-add" */ '@/view/assessment/master/proyeksi-jabatan/add.vue'
              ),
          },
          {
            path: 'proyeksi-jabatan-edit/:id',
            name: 'proyeksi-jabatan-edit',
            component: () =>
              import(
                /* webpackChunkName: "proyeksi-jabatan-edit" */ '@/view/assessment/master/proyeksi-jabatan/edit.vue'
              ),
          },
          {
            path: 'proyeksi-jabatan-import',
            name: 'proyeksi-jabatan-import',
            component: () =>
              import(
                /* webpackChunkName: "proyeksi-jabatan-import" */ '@/view/assessment/master/proyeksi-jabatan/import.vue'
              ),
          },
          {
            path: 'pegawai',
            name: 'pegawai',
            component: () =>
              import(/* webpackChunkName: "pegawai-assessment" */ '@/view/assessment/master/pegawai/index.vue'),
          },
          {
            path: 'pegawai-import',
            name: 'pegawai-import',
            component: () =>
              import(/* webpackChunkName: "pegawai-assessment-import" */ '@/view/assessment/master/pegawai/import.vue'),
          },
          {
            path: 'pegawai-eligible',
            name: 'pegawai-eligible',
            component: () =>
              import(/* webpackChunkName: "pegawai-eligible" */ '@/view/assessment/master/pegawai-eligible/index.vue'),
          },
          {
            path: 'pegawai-eligible-import',
            name: 'pegawai-eligible-import',
            component: () =>
              import(
                /* webpackChunkName: "pegawai-eligible-import" */ '@/view/assessment/master/pegawai-eligible/import.vue'
              ),
          },
          {
            path: 'user',
            name: 'user',
            component: () =>
              import(/* webpackChunkName: "user-assessment" */ '@/view/assessment/master/user/index.vue'),
          },
          {
            path: 'informed-consent',
            name: 'informed-consent',
            component: () =>
              import(
                /* webpackChunkName: "informed-consent-assessment" */ '@/view/assessment/master/informed-consent/index.vue'
              ),
          },
          {
            path: 'informed-consent-add',
            name: 'informed-consent-add',
            component: () =>
              import(
                /* webpackChunkName: "informed-consent-assessment-add" */ '@/view/assessment/master/informed-consent/add.vue'
              ),
          },
          {
            path: 'informed-consent-edit/:id',
            name: 'informed-consent-edit',
            component: () =>
              import(
                /* webpackChunkName: "informed-consent-assessment-edit" */ '@/view/assessment/master/informed-consent/edit.vue'
              ),
          },
        ],
      },
    ],
  },
];
